/**
 * Finds what the player is standing near, and shows the prompt for it.
 *
 * Proximity is measured against each location's declared entry point rather
 * than its centre, so the prompt appears where the door is - which is what
 * makes an interaction feel like it belongs to the building rather than to an
 * invisible trigger volume.
 */
import { LOCATIONS, type WorldLocation } from '../sim/data/world.js';

export const INTERACT_RADIUS = 6.5;

export function findNearestLocation(x: number, z: number): WorldLocation | null {
  let best: WorldLocation | null = null;
  let bestDistance = INTERACT_RADIUS;
  for (const location of LOCATIONS) {
    const ex = location.x + location.entryX;
    const ez = location.z + location.entryZ;
    const distance = Math.hypot(x - ex, z - ez);
    if (distance < bestDistance) {
      bestDistance = distance;
      best = location;
    }
  }
  return best;
}
